import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BREAKPOINTS_MAX } from "@dexibit/styles";

import type { RootState } from "../../store";

export interface SidebarState {
  collapsed: boolean;
}

export interface LayoutState {
  layouts: Record<string, { leftSidebar: SidebarState }>;
}

const isMobileViewport = () => window.innerWidth <= BREAKPOINTS_MAX.mobile;

const initialState: LayoutState = {
  layouts: {
    "root-page": { leftSidebar: { collapsed: isMobileViewport() } },
    "almanac-page": { leftSidebar: { collapsed: isMobileViewport() } },
  },
};

export const selectLayout = createSelector(
  (state: RootState) => state,
  (state) => state.layout,
);

export const selectLayoutById = (layoutId: string) =>
  createSelector(selectLayout, (layout) => layout.layouts[layoutId]);

export const selectLeftSidebarCollapsed = (layoutId: string) =>
  createSelector(
    selectLayoutById(layoutId),
    (layout) => layout?.leftSidebar.collapsed ?? false,
  );

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLeftSidebarCollapsed: (
      state,
      action: PayloadAction<{ layoutId: string; collapsed: boolean }>,
    ) => {
      const { layoutId, collapsed } = action.payload;
      if (!state.layouts[layoutId]) {
        state.layouts[layoutId] = { leftSidebar: { collapsed: false } };
      }
      state.layouts[layoutId].leftSidebar.collapsed = collapsed;
    },
  },
});

export const { setLeftSidebarCollapsed } = layoutSlice.actions;
